<div>
  <div class='admin-component'>
      <login-generate-password-form [resetUserPasswordForm]='resetUserPasswordForm'></login-generate-password-form>
      <login-new-user-form [newUserForm]='newUserForm' [accounts]="accounts"></login-new-user-form>
  </div>
</div>

